import React from "react";
import propTypes from "prop-types";
import classnames from "classnames";

const ErrorsForField = ({ id, errors }) => {
  if (!errors) {
    return null;
  }
  const classes = classnames("uikit__errors__list", {
    uikit__errors__mulitple: errors?.length > 1
  });
  return (
    <ul id={id} className={classes}>
      {errors.map(e => (
        <li key={e} className="uikit__errors__item">
          {e}
        </li>
      ))}
    </ul>
  );
};

export default ErrorsForField;

ErrorsForField.propTypes = {
  id: propTypes.string.isRequired,
  errors: propTypes.array
};
